



























































































































































import { Component, PropSync, Vue } from "vue-property-decorator";
import { FinDocViewModel } from "./models";
import NumericInputImproved from "@/components/numbers/NumericInputImproved.vue";
import { Getter } from "vuex-class";
import { FinancialSettingsType } from "@/store/modules/financial";
import CurrencyDisplay from "@/components/misc/CurrencyDisplay.vue";
import AdvancePicker from "./AdvancePicker.vue";
import {
  FinancialDocumentStatusEnum,
  FinancialDocumentTypesEnum,
} from "@/shared/models/enums.type";
import { getPriceSummary } from "./functions";
import TaxRecap from "./TaxRecap.vue";

@Component({
  components: {
    NumericInputImproved,
    CurrencyDisplay,
    AdvancePicker,
    TaxRecap,
  },
})
export default class PriceSummary extends Vue {
  @PropSync("finDocModel") finDocModelInternal!: FinDocViewModel;
  @PropSync("hasTaxRecapError", { default: false })
  hasTaxRecapErrorInternal?: boolean;

  @PropSync("automaticallyCancelRelatedAdvanceInvoices")
  automaticallyCancelRelatedAdvanceInvoicesInternal?: boolean;

  get isCancellation() {
    return (
      this.finDocModelInternal.documentTypeId ===
      FinancialDocumentTypesEnum.Storno
    );
  }

  advancePickerOpen = false;
  get canChooseAdvances() {
    return (
      this.finDocModelInternal.documentTypeId ===
        FinancialDocumentTypesEnum.Racun &&
      this.finDocModelInternal.documentStatusId ===
        FinancialDocumentStatusEnum.UIzradi
    );
  }

  get workingCurrency() {
    return {
      id: this.finDocModelInternal.workingCurrencyId,
      code: this.finDocModelInternal.workingCurrencyISO3,
    };
  }

  get formalCurrency() {
    if (!this.finDocModelInternal.formalCurrencyId) return null;

    return {
      id: this.finDocModelInternal.formalCurrencyId,
      code: this.finDocModelInternal.formalCurrencyISO3,
    };
  }

  get summary() {
    return getPriceSummary(this.finDocModelInternal);
  }

  @Getter("financial/settings") storedSettings?: FinancialSettingsType;

  get tenantPaysVat() {
    return this.storedSettings?.paysVat ?? false;
  }
}
